
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nscf0ad8004758c3ff22ce19c5478d3de2en from './en.yaml'
            i18n.addResourceBundle('en', 'cf0ad8004758c3ff22ce19c5478d3de2', flattenObject(nscf0ad8004758c3ff22ce19c5478d3de2en), true, true);
        
        export default 'cf0ad8004758c3ff22ce19c5478d3de2';
    